import api from "@/services/api";

const state = {
  vendors: [],
};

const mutations = {
  SET_Vendors(state, vendors) {
    state.vendors = vendors;
  },
};

const actions = {
  async getVendors({ commit }) {
    try {
      const res = await api.get("/vendors");
      commit("SET_Vendors", res.data);
    } catch (error) {
      console.error("Error fetching vendors:", error.message);
      throw error;
    }
  },

  async createVendor({ dispatch }, vendorData) {
    try {
      let result = await api.post("/vendors", vendorData);
      await dispatch("getVendors");
      return result.data;
    } catch (error) {
      console.error("Error creating vendor:", error.message);
      throw error;
    }
  },

  async getVendorById(_, vendorId) {
    try {
      const res = await api.get(`/vendors/${vendorId}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching vendor by ID:", error.message);
      throw error;
    }
  },

  async updateVendor({ dispatch }, { vendorId, vendorData }) {
    try {
      await api.put(`/vendors/${vendorId}`, vendorData);
      await dispatch("getVendors");
    } catch (error) {
      console.error("Error updating vendor:", error.message);
      throw error;
    }
  },

  async deleteVendor({ dispatch }, vendorId) {
    try {
      await api.delete(`/vendors/${vendorId}`);
      await dispatch("getVendors");
    } catch (error) {
      console.error("Error deleting vendor:", error.message);
      throw error;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
